import { UserModel } from '@picsart/growth-rc/AuthContext';
import {
  UserSubscription,
  UserSubscriptionResponse,
} from '@picsart/monetization/types/models/userSubscriptionModel';
import { fetchUserSubscription } from '@picsart/monetization/userService';

import { fetchSubscriptionPlans } from '@picsart/monetization/subscriptionsService';

import { apiUrl } from 'constants/main';

import { authorizationHeader } from '@picsart/growth-rc/services/auth';

// Get the gold user code (url) for redirecting
// it must work only for gold users
const getUrlForDiscord = async (user: UserModel, path: string, accessToken: string) => {
  const teamId = user?.teams?.[0]?.id;
  const data = teamId ? { teamId } : {};
  const url = `${apiUrl}/${path}`;

  await fetch(url, {
    headers: authorizationHeader(accessToken),
    body: JSON.stringify(data),
    method: 'POST',
  })
    .then((res: any) => {
      if (res.status === 'success') {
        window.location.href = res.code;
      } else {
        window.location.href = '/gold/error';
      }
    })
    .catch(() => {
      window.location.href = '/gold/error';
    });
};

const getUserSubscription = async (
  accessToken: string,
  expand = true,
): Promise<UserSubscription | null> => {
  try {
    const response: UserSubscriptionResponse = await fetchUserSubscription({ expand }, accessToken);
    if (response.status === 'success') {
      return response.data;
    }
    return null;
  } catch (e) {
    console.trace(e);

    return null;
  }
};

const getSubscriptionPlan = async (scope?: string) => {
  try {
    const { data, status } = await fetchSubscriptionPlans(scope);
    if (status === 'success' && data.length) {
      return data;
    }
    return [];
  } catch (e) {
    console.trace(e);
    return [];
  }
};

const getIsPromoCodeActive = async (
  accessToken: string,
  queryVal: { code?: string },
): Promise<boolean> => {
  const url = `${apiUrl}/shop/subscription/promos/redeem`;
  const defaultRedeemError = 'COMPANY_PROMO_REDEEM_ERROR__ERROR_UNKNOWN';
  const data: any = await fetch(url, {
    headers: {
      'content-type': 'application/json',
      ...authorizationHeader(accessToken),
    },
    body: JSON.stringify(queryVal),
    method: 'POST',
  });
  if (data.status >= 400) {
    const resp = await data.json();
    throw new Error(resp.reason || defaultRedeemError);
  }
  return true;
};

export { getIsPromoCodeActive, getSubscriptionPlan, getUrlForDiscord, getUserSubscription };
